type ScreenSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export type Screens = {
  [key in ScreenSize]: number;
};

export const screens: Screens = {
  xs: 380, // mediumMobileUp
  sm: 576, // largeMobileUp
  md: 768, // tabletUp
  lg: 992, // largeTabletUp
  xl: 1200, // smallDesktopUp
  '2xl': 1440, // desktopUp
};

type ScreensConfig = {
  [key in ScreenSize]: string;
};

export const configScreens: ScreensConfig = {
  xs: `${screens.xs}px`,
  sm: `${screens.sm}px`,
  md: `${screens.md}px`,
  lg: `${screens.lg}px`,
  xl: `${screens.xl}px`,
  '2xl': `${screens['2xl']}px`,
};
